import { gql } from '@apollo/client';

export const FETCH_RESOURCE_GROUPS = gql`
  query FetchResourceGroups {
    facility {
      resourceGroups {
        id
        name
        processVariableIds
        processIds
        isPublic
        users {
          id
          user {
            id
            username
          }
        }
        noiseEventPolicy
        reportDefinitionIds
        enabledOverrideCount
        disabledOverrideCount
      }
    }
  }
`;
